import { HateoasResource } from '@lagoshny/ngx-hateoas-client';
import { CompanyCategory } from '../company/company-category.model';
import { CompanyOwned } from '../company/company-models.model';

@HateoasResource('elementgroupcode')
export class ElementGroupCode extends CompanyOwned {
  public categorie: CompanyCategory | undefined | null;
  public groeptype: ElementGroupCodeType | null | undefined;
  public naam: string | undefined;
  public verborgen: boolean | undefined;
  public master: string | undefined;

  public used: boolean | undefined;
}

export enum ElementGroupCodeType {
  OBJECT_ELEMENTS = 'objectelementen',
  SCENARIO_RULES = 'scenarioregels',
}
